import React from 'react';
import PropTypes from 'prop-types';
import MicrosoftSignInButton from './MicrosoftSignInButton';
import AzureAuthenticationContext from './AzureAuthenticationContext';

const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');
const msie11 = ua.indexOf('Trident/');
const isIE = msie > 0 || msie11 > 0;

const AzureAuthenticationButton = ({ onAuthenticate, theme, azureClientId }) => {
    const authenticationModule = new AzureAuthenticationContext(azureClientId);

    const logIn = () => {
        const typeName = 'loginPopup';
        const logInType = isIE ? 'loginRedirect' : typeName;
        authenticationModule.login(logInType, onAuthenticate);
    };

    return (
        <div id="authentication">
            {authenticationModule.isAuthenticationConfigured ? (
                <MicrosoftSignInButton
                    onClick={() => logIn('loginPopup')}
                    theme={theme}
                />
            ) : null}
        </div>
    );
};

AzureAuthenticationButton.propTypes = {
    onAuthenticate: PropTypes.func.isRequired,
    theme: PropTypes.oneOf(['light', 'dark']),
    azureClientId: PropTypes.string.isRequired,
};

AzureAuthenticationButton.defaultProps = {
    theme: 'light',
};

export default AzureAuthenticationButton;
